"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("../../../theme/makeStyles");
var theme_1 = __importDefault(require("../../../theme"));
exports.default = (0, makeStyles_1.makeStyles)(function (_a) {
    var _b, _c;
    var breakpoints = _a.breakpoints;
    return ({
        row: {
            display: 'grid',
            gridColumnGap: '16px',
            padding: '0 16px',
            maxWidth: '1280px'
        },
        'full-width': {
            width: '100%',
            maxWidth: 'unset',
            padding: '0 24px'
        },
        'row-sm': {
            gridTemplateColumns: 'repeat(4, minmax(auto, 1fr))'
        },
        'row-md': (_b = {},
            _b["@media only screen and (min-width: ".concat(breakpoints.medium, "px)")] = {
                gridTemplateColumns: 'repeat(12, minmax(auto, 1fr))',
                gridColumnGap: '24px',
                padding: '0 24px'
            },
            _b),
        'row-lg': (_c = {},
            _c["@media only screen and (min-width: ".concat(breakpoints.large, "px)")] = {},
            _c),
        nested: {
            padding: 0
        },
        'row-gap': function (_a) {
            var gridRowGap = _a.gridRowGap;
            return ({
                gridRowGap: gridRowGap ? theme_1.default.spacing(gridRowGap) : 0
            });
        }
    });
});
